import Image from 'next/image';
import style from './index.module.scss'
import parse, { Element, HTMLReactParserOptions } from 'html-react-parser';
import Link from 'next/link';

interface ITextImageBlockProps {
    title: string;
    text: string[];
    imageSrc: string;
    imageAlt?: string;
    asTitle?: boolean;
    asSubTitle?: boolean;
}

export const TextImageBlock = ({ title, text, imageSrc, imageAlt, asTitle, asSubTitle }: ITextImageBlockProps) => {
    let lastArrayIndex = text.length - 1;
    const options: HTMLReactParserOptions = {
      replace: (domNode) => {
        if (domNode instanceof Element && domNode.attribs) {
          if (domNode.attribs.class === 'link-item') {
            const href = domNode.attribs['data-href'];
            const content = domNode.attribs['data-content'];
            return <Link href={href}><a>{ content }</a></Link>
          }
        }
      }
    };

    return (
        <div className={`${style.block}`}>
            <div className={`${style.block__item}`}>
           {
              asTitle
                ? <h1 className={style.title}>{title}</h1>
                : asSubTitle
                  ? <h2 className={style.title}>{title}</h2>
                  : <div className={style.title}>{title}</div>
              }
              <div className={`${style.text__block}`}>
                    {
                        text.map((item: string, index: number) => {
                            return (
                                <div className={`${style.text__item} ${lastArrayIndex === index ? style.text__item_last : null}`} key={index}>
                                  { parse(item, options) }
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={`${style.image}`}>
                <Image src={imageSrc} alt={imageAlt || title} layout={'fill'} sizes={'300'} />
            </div>
        </div>
    )
}
